<template>
  <svg
    class="lgf-spinner"
    viewBox="0 0 211.5 211.4"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g class="lgf-spinner__disc">
      <path
        class="lgf-spinner__st0"
        d="M105.7 211.4a105 105 0 01-35.2-6l3.4-8.8a95.28 95.28 0 0031.8 5.4 94 94 0 0032-5.5l3.4 8.9a106.58 106.58 0 01-35.4 6z"
      />
      <path
        class="lgf-spinner__st1"
        d="M63.5 202.6a105.69 105.69 0 01.2-193.9l3.4 8.9a96.24 96.24 0 00-.2 176.2z"
      />
      <path
        class="lgf-spinner__st2"
        d="M144.7 193.7a96.27 96.27 0 00-.1-176.1l3.4-8.8a105.72 105.72 0 01.1 193.8z"
      />
      <path
        class="lgf-spinner__st0"
        d="M137.5 14.9a96.59 96.59 0 00-63.4-.1L70.7 6a103.85 103.85 0 0135-6 105 105 0 0135.2 6z"
      />
    </g>
    <g class="lgf-spinner__cup">
      <path
        class="lgf-spinner__st1"
        d="M147 43.4a2.46 2.46 0 00-2-1H65.2a2.61 2.61 0 00-2 1 3.41 3.41 0 00-.7 2.4l7 118.2c.2 4 3.1 7.2 6.6 7.2h58.3c3.4 0 6.3-3.1 6.6-7.2l7-118.2a4.73 4.73 0 00-1-2.4zm-4.9 5.4l-1.5 24.7h-71l-1.5-24.7zm-2.8 30.7l-3.8 62.9H74.7l-3.8-62.9zm-5.1 85.1H76a1.1 1.1 0 01-1-1.1l-.9-15h62.1l-.9 15a1.18 1.18 0 01-1.1 1.1z"
      />
      <path
        class="lgf-spinner__st2"
        d="M105.1 89.8l6.6 13.3 14.6 2.1-10.6 10.4 2.5 14.6-13.1-6.9-13.1 6.9 2.5-14.6-10.6-10.4 14.6-2.1 6.6-13.3z"
      />
      <path
        class="lgf-spinner__st3"
        d="M118.2 130.2l-.1-.5-.3.2.4.3zM96.8 100.7l1.4-2.9-5.2 3.4 3.8-.5z"
      />
      <path
        class="lgf-spinner__st1"
        d="M70.9 76.5l.3-.3h-.3v.3zM79.7 76.2h-1.2l-7.6 5.1v.8l8.8-5.9zM88.2 76.2H87L70.9 86.9v.8l17.3-11.5zM96.8 76.2h-1.3L70.9 92.5v.9l25.9-17.2zM105.3 76.2H104l-33.1 22v.8l34.4-22.8zM113.8 76.2h-1.2l-41.7 27.6v.8l42.9-28.4zM103.1 88.1l-32.2 21.3v.8l31.5-20.8.4-.8c0-.2.2-.3.3-.5zM105.6 87.3l16.7-11h-1.2l-16.8 11a1.7 1.7 0 01.7-.1c.3 0 .5 0 .6.1zM98.2 97.8l.6-1.2-7.4 4.9 1.6-.3 5.2-3.4zM130.8 76.2h-1.2l-21.3 14.1.3.6 22.2-14.7zM70.9 115.1v.8l12-8-.5-.5-11.5 7.7zM139.3 76.2h-1.2l-27.7 18.4.3.6 28.6-19zM70.9 120.7v.8l15.5-10.2-.5-.5-15 9.9zM139.3 81.9V81l-26.8 17.8.3.6 26.5-17.5zM70.9 126.4v.8l18.9-12.6-.5-.4-18.4 12.2zM139.3 87.5v-.8l-22 14.6 1 .1 21-13.9zM70.9 132v.8l20.3-13.4.1-1L70.9 132zM70.9 137.6v.8l19.2-12.7.1-.9-19.3 12.8zM139.3 93.1v-.8l-15 10 1 .1 14-9.3zM128.9 105.7l10.5-6.9V98l-10.4 6.9a2 2 0 00-.1.8zM72.1 142.5h1.2l16.5-10.9-.3-.6zM80.6 142.5h1.2l24-15.9-.7-.4-24.5 16.3zM139.3 104.4v-.8l-20.6 13.7.1.7 20.5-13.6zM89.1 142.5h1.2l20.2-13.4-.6-.4-20.8 13.8zM139.3 110v-.8l-19.8 13.1.1.8 19.7-13.1zM97.6 142.5h1.3l16.4-10.9-.7-.4-17 11.3zM139.3 115.7v-.8l-18.9 12.5.1.7 18.8-12.4zM139.3 121.3v-.8l-33.2 22h1.3l31.9-21.2zM139.3 126.9v-.8l-24.6 16.4h1.2l23.4-15.6zM139.3 132.6v-.8l-16.1 10.7h1.2l14.9-9.9zM139.3 138.2v-.8l-7.6 5.1h1.2l6.4-4.3z"
      />
      <path
        d="M115.3 131.6l1.7.9a2.66 2.66 0 001.2.3 2.69 2.69 0 001.5-.5 2.6 2.6 0 001-2.6l-.3-1.6-.1-.7-.7-4.3-.1-.7-.7-4.3-.1-.7-.1-.8 9.6-9.4a2.67 2.67 0 00.7-1.4v-.8a.9.9 0 00-.1-.5 2.77 2.77 0 00-2.1-1.8l-1.4-.2-1-.1-6-.9-1-.1-3.9-.6-.6-1.3-.3-.6-1.8-3.6-.3-.6-1.8-3.6-.3-.6-.8-1.7a2.83 2.83 0 00-1.8-1.4 4.33 4.33 0 01-.5-.1 1.48 1.48 0 00-.7.1 2 2 0 00-1.2.8c-.1.2-.3.3-.4.5l-.4.8-3.5 7.2-.6 1.2-1.4 2.9-3.8.6-1.6.2-7.9 1.2a2.45 2.45 0 00-2.1 1.8 2.53 2.53 0 00.7 2.7l.4.4.5.5 2.9 2.9.3.2 2.9 2.9.5.5 1.9 1.8-.3 2-.2.9-.9 5.4-.2.9-.7 4a2.46 2.46 0 00.1 1.2l.3.6a2.34 2.34 0 00.7.7 3 3 0 001.5.5 2.66 2.66 0 001.2-.3l11.9-6.3.7.4 4.1 2.1.7.4 4.1 2.1zm-29-26.7l1.6-.2 9.3-1.4 1.3-.2.5-1 3.5-7.2.6-1.2 1.9-3.9 1 2 .3.6 1.8 3.6.3.6 1.8 3.6.3.6 1.1 2.2 2.4.3 1 .1 6 .9 1 .1 4.3.6-4.3 4.2-2.6 2.5-3.7 3.6.6 3.3.1.7.7 4.3.1.7.7 4.3.1.7.1.5-.4-.2-.7-.4-4.1-2.1-.7-.4-4.1-2.1-.7-.4-2.5-1.3-13.1 6.9v-.1l.2-.9.9-5.4.2-.9.9-5.4.2-.9.2-.9-2.5-2.4-.5-.5-2.9-2.9-.5-.5-2.9-2.9-.5-.5-.8-.8"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LgfSpinner',
};
</script>

<style lang="scss" scoped>
.lgf-spinner {
  $lgf-spinner-transition-duration: 1000ms;

  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: middle;

  &__disc {
    animation: spinner-disk-rotate $lgf-spinner-transition-duration infinite;
    transform-origin: center;
  }

  &__cup {
    animation: spinner-cup-bounce $lgf-spinner-transition-duration infinite
      ease-in-out;
    transform-origin: center;
  }

  &__st0 {
    fill: $color-gray-gallery;
  }

  &__st1 {
    fill: $color-primary;
  }

  &__st2 {
    fill: $color-red-amaranth;
  }

  &__st3 {
    fill: none;
  }
}

@keyframes spinner-disk-rotate {
  0%,
  50% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-cup-bounce {
  0%,
  60%,
  90%,
  100% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }
}
</style>
